import React, { useState, useEffect } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Tag } from 'primereact/tag';
import { fetchProduct, fetchProducts, updateProduct } from '../apis/products';
import { useMediaQuery } from 'react-responsive';
import { TabMenu } from 'primereact/tabmenu';
// import React, { useState, useEffect } from 'react';
// import { DataTable } from 'primereact/datatable';
// import { Column } from 'primereact/column';
// import { Tag } from 'primereact/tag';
// import { useMediaQuery } from 'react-responsive';
// import { fetchRiders, fetchRider, updateRider } from '../apis/product';
import { Button } from 'primereact/button';
// import { TabMenu } from 'primereact/tabmenu';
import toast, { Toaster } from 'react-hot-toast';
import { Dialog } from 'primereact/dialog';
import ProductInfoDialog from './ProductInfoDialog.tsx';

export default function Products() {
    const filterChange = useMediaQuery({ maxWidth: 768 });
    const productLimit = 15;
    const [products, setProducts] = useState([]);
    const [product, setProduct] = useState();
    const [selectedProduct, setSelectedProduct] = useState(null);
    // const [globalFilter, setGlobalFilter] = useState('');
    // const [rowClick, setRowClick] = useState(true);
    const [visible, setVisible] = useState(false);
    const [loading, setLoading] = useState(false);
    const [first, setFirst] = useState(0);
    const [page, setPage] = useState(0);
    const [totalPage, setTotalPage] = useState(0);
    const [activeIndex, setActiveIndex] = useState(0);

    const tabItems = [
        { label: 'Approved' },
        { label: 'Pending' },
        { label: 'Rejected' }
    ];

    const getProducts = async (page, index) => {

        try {
            setLoading(true);
            const status = index === 0 ? 'approved' : index === 1 ? 'pending' : 'rejected';
            const products = await fetchProducts(page, status);

            if (products.length === 0) {
                setProducts(products);
                setTotalPage(0);
                return;
            }

            setTotalPage(parseInt(products[0]['size']));
            setProducts(products);

        } catch (error) {
            console.error("Error fetching Orders: ", error);
        } finally {
            setLoading(false);
        }

    }

    const getProduct = async (e) => {
        try {
            const productId = e.data['productId'];
            setLoading(true);
            if (e.data != null) {
                const product = await fetchProduct(productId);
                setVisible(true);
                console.log(product);
                setProduct(product);
                toast.success('Product Fetched');
            }
        } catch (error) {
            setVisible(false);
            console.log(error);
            const errorText = error['response']['statusText'];
            toast.error(`Error Getting Product Details - ${errorText}`);
        } finally {
            setLoading(false);
        }
    }

    // useEffect(() => {
    //     getProducts(0);
    // }, []);

    useEffect(() => {
        getProducts(0, activeIndex);
    }, [activeIndex]);

    const onPage = async (event) => {
        setFirst(event.first);
        setPage(event.page);
        getProducts(event.page, activeIndex);
    };

    const formatCurrency = (value) => {
        return value.toLocaleString('en-US', { style: 'currency', currency: 'INR' });
    };

    const priceBodyTemplate = (order) => {
        return formatCurrency(order.withGstprice);
    };

    const imageBodyTemplate = (product) => {

        return (
            <img
                // src={`data:image/jpeg;base64,${product.image}`}
                src={`${product.image}`}
                alt="Product"
                style={{ width: '80px', height: '60px', objectFit: 'cover', borderRadius: '10px' }}
            />
        );
    };

    const statusBodyTemplate = (product) => {
        return <Tag value={String(product.isInstock)} severity={getSeverity(product)}></Tag>;
    };

    const getSeverity = (product) => {
        switch (String(product.isInstock)) {
            case 'false':
                return 'warning';

            case 'true':
                return 'success';

            default:
                return null;
        }
    };

    const modifyProduct = async (action, id) => {
        try {
            console.log(action);
            console.log(id);

            const data = await updateProduct(id, action);

            console.log('184 after update product');
            console.log(data);

            if (page > 0 && products.length === 1) {
                await getProducts(page - 1, activeIndex);
            } else {
                await getProducts(page, activeIndex);
            }
        } catch (error) {
            toast.error('Error verifying product');
        }
    };


    const onRowSelect = (event) => {
        // setVisible(true);
        console.log('246 - row select');
        getProduct(event);
        // toast.current.show({ severity: 'info', summary: 'Product Selected', detail: `Name: ${event.data.username}`, life: 3000 });
    };

    const onRowUnselect = (event) => {
        setVisible(false);
        setSelectedProduct(null);
        // toast.current.show({ severity: 'warn', summary: 'Product Unselected', detail: `Name: ${event.data.username}`, life: 3000 });
    };

    const hideDialog = () => {
        if (!visible) return;
        setVisible(false);
        // setSelectedVendor(null);;
        setSelectedProduct(null);
    }

    return (
        <>
            {/* <div style={{ display: 'flex', flexDirection: 'column' }} className="card h-screen overflow-auto"> */}
            <Toaster />
            <div className="card">
                {/* <h2 style={{ marginBlock: '1rem' }}>All Products</h2> */}
                <TabMenu
                    model={tabItems}
                    activeIndex={activeIndex}
                    onTabChange={(e) => setActiveIndex(e.index)}
                    pt={{
                        menu: { className: 'gap-2 mb-2' } // Tailwind: adds space between items
                    }}
                />
                {/* <div className='flex-1'> */}
                <DataTable value={products} lazy paginator rows={productLimit} totalRecords={totalPage} first={first} onPage={onPage} loading={loading} loadingIcon="pi pi-spin pi-cog" emptyMessage={!loading && `No products found`} tableStyle={{ minWidth: '50rem' }} selection={selectedProduct} onSelectionChange={(e) => {
                    setSelectedProduct(e.value);
                }} onRowSelect={onRowSelect} onRowUnselect={onRowUnselect} scrollable scrollHeight={filterChange ? '60vh' : '75vh'} paginatorTemplate="PrevPageLink NextPageLink CurrentPageReport"
                    currentPageReportTemplate="Total Products: {totalRecords}">
                    <Column selectionMode="single" headerStyle={{ width: '3rem' }}></Column>
                    <Column field="image" header="Image" body={imageBodyTemplate}></Column>
                    <Column field="name" header="Name"></Column>
                    <Column field="withGstprice" header="Price" body={priceBodyTemplate}></Column>
                    <Column field="category" header="Category"></Column>
                    {/* <Column field="isInstock" header="Stock Status" body={statusBodyTemplate}></Column> */}
                    <Column header="Action" body={(rowData) => (
                        activeIndex === 0
                            ?
                            <Button icon="pi pi-ban" label="Reject" tooltip='Reject this product' size='small' severity='danger' onClick={() => modifyProduct('rejected', rowData.productId)} />
                            :
                            activeIndex === 1 ?
                                <>
                                    <Button icon="pi pi-check" label="Approve" tooltip='Approve this product' size='small' severity="success" className="mr-4" onClick={() => modifyProduct('approved', rowData.productId)} />
                                    <Button icon="pi pi-ban" label="Reject" tooltip='Reject this product' size='small' severity="danger" onClick={() => modifyProduct('rejected', rowData.productId)} />
                                </>
                                :
                                <Button icon="pi pi-check" label="Approve" tooltip='Approve this product' size='small' severity="success" onClick={() => modifyProduct('approved', rowData.productId)} />
                    )} />
                </DataTable>
                {/* </div> */}
            </div>
            {/* <Dialog
                header="Product Info"
                visible={visible}
                onHide={hideDialog}
                style={{ width: '50vw' }}
                className="p-fluid"
            >
                {
                    product ?
                        <div className="p-d-flex p-ai-center">
                            <div>
                                <p><strong>Name:</strong> {product.name}</p>
                                <p><strong>Email:</strong> {product.email}</p>
                                <p><strong>Phone Number:</strong> {product.phoneNumber}</p>
                                <p><strong>Aadhar Number:</strong> {product.aadharNumber}</p>
                                <p><strong>PAN Number:</strong> {product.panNumber}</p>
                                <p><strong>Verified:</strong> {product.isVerified ? "Yes" : "No"}</p>
                            </div>
                        </div>
                        : <></>
                }
            </Dialog> */}

            <ProductInfoDialog
                visible={visible}
                onHide={hideDialog}
                product={product}
            />

            
            {/* <Dialog
                header="Product Info"
                visible={visible}
                onHide={hideDialog}
                style={{ width: '50vw' }}
                className="p-fluid"
            >
                {
                    product ?
                        <div style={{ display: 'flex', alignItems: 'flex-start', gap: '2rem' }}>
                            <div>
                                <img
                                    src={product.image}
                                    alt={product.name}
                                    style={{ width: '200px', height: '200px', objectFit: 'cover', borderRadius: '8px' }}
                                />
                            </div>
                            <div>
                                <p><strong>Name:</strong> {product.name}</p>
                                <p><strong>Description:</strong> {product.description}</p>
                                <p><strong>Category:</strong> {product.category}</p>
                                <p><strong>HSN Code:</strong> {product.hsnCode}</p>
                                <p><strong>Quantity:</strong> {product.quantity} {product.unit}</p>
                                <p><strong>Price (Excl. GST):</strong> ₹{product.price}</p>
                                <p><strong>Price (Incl. GST):</strong> ₹{product.withGstprice}</p>
                                <p><strong>GST:</strong> {product.gst}%</p>
                                <p><strong>In Stock:</strong> {product.isInstock ? "Yes" : "No"}</p>
                                <p><strong>Status:</strong> {product.status}</p>
                                <p><strong>Nutrition Info:</strong><br />
                                    <span style={{ whiteSpace: 'pre-line' }}>{product.nutritionInfo}</span>
                                </p>
                            </div>
                        </div>
                        : <></>
                }
            </Dialog> */}

        </>
    );
}

